import { Row } from "style/preset"
import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"

import { ReactComponent as BrowserSvg } from 'assets/svgs/browser_icon.svg'
import { ReactComponent as SwapSvg} from "assets/svgs/swap_icon.svg"

import { ReactComponent as ArrowRight2Svg } from "assets/svgs/arrow_right_2.svg"
import { useCallback } from "react"
import { DefaultTheme } from "styled-components/dist/types"

import { ReactComponent as WarnSvg } from 'assets/svgs/waring_icon.svg' 
import { ReactComponent as AllRightSvg } from 'assets/svgs/allRight.svg' 
import { ReactComponent as TicketSupportSvg } from 'assets/svgs/ticket_support.svg'
import { ReactComponent as BtcEngraveSvg } from 'assets/svgs/btc_engrave.svg'

interface Props {
    title?: string
    type?: string
    disabled?: boolean
    onClick?: () => void
}

const BaseBtnCom = ({title, type = '0', disabled=false, onClick= () => {}}: Props) => {
    const getIcon = useCallback(() => {
        switch(type) {
            case '0':
                return <BrowserSvgWrap></BrowserSvgWrap>
            case '1':
                return <SwapSvgWrap></SwapSvgWrap>
            case '2':
                return <WarnSvgWrap></WarnSvgWrap>
            case '3':
                return <AllRightSvgWrap></AllRightSvgWrap>
            case '4':
                return <TicketSupportSvgWrap></TicketSupportSvgWrap>
            case '5':
                return <BtcEngraveSvgWrap></BtcEngraveSvgWrap>
            default:
                return <BrowserSvgWrap></BrowserSvgWrap>
        }
    }, [type])

    const fnOnClick = useCallback(() => {
        if(disabled) {
            return;
        }
        onClick()
    }, [disabled, onClick])

    return <BaseBtnwrap $active={!disabled} $type={type} onClick={fnOnClick}>
        <Row>
            {getIcon()}
            <BtnTitleWrap>{title}</BtnTitleWrap>
        </Row>
        <ArrowRight2SvgWrap></ArrowRight2SvgWrap>
    </BaseBtnwrap>
}

const baseBgColor = ($type: string, theme: DefaultTheme) => {
    return css`
    background-color: ${['0', '3'].includes($type) ? theme.basicBlack : theme.basicPurple };
    `
}
const svgStyle = () => {
    return css`
        width: 20px;
        height: 20px;
    `
}

const BtnTitleWrap = styled(StyledContainer)`
    font-family: RoobertSemiBold;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    color: ${({theme}) => theme.basicWhite};
    margin-left: 14px;

`

const BrowserSvgWrap = styled(BrowserSvg)`
    ${svgStyle()}
`

const SwapSvgWrap = styled(SwapSvg)`
    ${svgStyle()}
`

const WarnSvgWrap = styled(WarnSvg)`
    ${svgStyle()}
`

const AllRightSvgWrap = styled(AllRightSvg)`
    ${svgStyle()}
`

const TicketSupportSvgWrap = styled(TicketSupportSvg)`
    ${svgStyle()}
`

const BtcEngraveSvgWrap = styled(BtcEngraveSvg)`
    ${svgStyle()}
`

const ArrowRight2SvgWrap = styled(ArrowRight2Svg)`
    width: 16px;
    height: 16px;
`

const BaseBtnwrap = styled(StyledContainer)<{$active: boolean, $type: string}>`
    padding: 20px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    ${
        ({$active, theme, $type}) => $active ? css`
            ${baseBgColor($type, theme)}
            ${BtnTitleWrap} {
                color: ${({theme}) => theme.basicWhite};
            }
            ${BrowserSvgWrap}, ${SwapSvgWrap}, ${ArrowRight2SvgWrap}, ${WarnSvgWrap}, ${AllRightSvgWrap}, ${TicketSupportSvgWrap}, ${BtcEngraveSvgWrap} {
                rect, path {
                    fill: ${({theme}) => theme.basicWhite};
                }
            }
        ` : css`
            cursor: not-allowed;
            background-color: #F6F5F4;
            ${BtnTitleWrap} {
                color: #CACCCE;
            }
            ${BrowserSvgWrap}, ${SwapSvgWrap}, ${ArrowRight2SvgWrap}, ${WarnSvgWrap}, ${AllRightSvgWrap}, ${TicketSupportSvgWrap}, ${BtcEngraveSvgWrap} {
                rect, path {
                    fill: #CACCCE;
                }
            }
        ` 
    }
`

export default BaseBtnCom